import React, { Fragment, memo } from 'react'
import { Heading } from '~elements'
import EventsListItem from '../EventsListItem/EventsListItem'

import styles from '../CalendarEDP.module.scss'
import dayjs from 'utils/dayjs'
import { EventsByDate, EventsByMonth } from 'components/modules/Calendar/types/Event'
import { ArtistProps } from '../../Calendar/types'
import { DATE_FORMAT } from '~constants'

interface EventListProps {
  modalData: {
    // ctaBuyText?: string
    artist: ArtistProps
    ctaSoldOutText?: string
    showPriceInModal: boolean
  }
  filteredCalendarData?: EventsByDate
  hidePricing: boolean
  overrideApiSoldOutStatus: boolean
  paginatedEventsByDate: string[]
  eventsByMonth: EventsByMonth
}

const EventsList = ({
  modalData,
  filteredCalendarData,
  hidePricing,
  overrideApiSoldOutStatus,
  paginatedEventsByDate,
  eventsByMonth
}: EventListProps) => {
  return (
    <>
      {filteredCalendarData &&
        Object.keys(eventsByMonth ?? []).map((monthKey: string, index: number) => {
          const formattedCalendarMonth = dayjs(monthKey, DATE_FORMAT.YEAR_MONTH).format(DATE_FORMAT.MONTH_YEAR_LABEL)
          const paginatedEventByMonth = paginatedEventsByDate.map(date => dayjs(date).format(DATE_FORMAT.YEAR_MONTH))
          return (
            paginatedEventByMonth?.includes(monthKey) && (
              <Fragment key={index}>
                <div className={styles['month-label']}>
                  <Heading level={6}>{formattedCalendarMonth}</Heading>
                </div>
                <ul>
                  {Object.keys(eventsByMonth[monthKey]).map((event: string, index: number) => (
                    <EventsListItem
                      key={`Event-List-Item-${index}`}
                      date={event}
                      filteredCalendarData={filteredCalendarData}
                      paginatedEventsByDate={paginatedEventsByDate}
                      hidePricing={hidePricing}
                      modalData={modalData}
                      overrideApiSoldOutStatus={overrideApiSoldOutStatus}
                    />
                  ))}
                </ul>
              </Fragment>
            )
          )
        })}
    </>
  )
}

export default memo(EventsList)
